export class Utils {
    static filterData(data) {
        return data.filter(object => {
            return object['IsActive'] === true;
        });
    }
}
